import { Component, Input, OnInit } from '@angular/core';
import { InvoiceService } from '../../../../shared/services/invoice.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';


@Component({
  selector: 'app-add-invoice',
  templateUrl: './add-invoice.component.html',
  styleUrls: ['./add-invoice.component.scss']
})
export class AddInvoiceComponent implements OnInit {

  @Input() caseId : number;
  @Input() caseTypeId : number;

  isLoading: boolean = false;
  invoiceDescription: string = 'Client Invoice';

  constructor(
    private invoiceService: InvoiceService,
    public activeModal: NgbActiveModal) { 
    }


  ngOnInit(): void {
  }

  addInvoice(){

    this.isLoading = true;
    this.invoiceService.addInvoice( this.caseId, this.invoiceDescription ).subscribe((response : any) => {
 
      this.activeModal.close(response.invoice.id);

    });


  }



}
